import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { academylist, createevent, deleteevent, detailevent, listevent } from "../../../services/admin";
import Select from "react-select";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export default function Listcalendar() {
    const [events, setEvents] = useState([]);
    const [aclist, setACList] = useState([]);
    const [acaid, setAcaID] = useState("");
    const [acid, setAcID] = useState("");

    const [eventid, setEventID] = useState("");
    const [title, setTitle] = useState("");
    const [tloc, setTLoc] = useState("");
    const [tstart, setTStart] = useState("");
    const [tend, setTEnd] = useState("");
    const [tdesc, setTDesc] = useState("");
    const [tfile, setTFile] = useState("");
    const [turl, setTUrl] = useState("");
    const [eissue, setEIssue] = useState("No");

    const [curdate, setCurdate] = useState("");

    const [show, setShow] = useState(false);

    function handleshow() {
        setShow(true);
        setTitle("");
        setTLoc("");
        setTStart(moment(new Date()).format("YYYY-MM-DD"));
        setTEnd(moment(new Date()).format("YYYY-MM-DD"));
        setTDesc("");
        setTFile("");
        setErrMsg("");
    }

    function handleclose() {
        setShow(false);
        setTitle("");
        setTLoc("");
        setTStart(moment(new Date()).format("YYYY-MM-DD"));
        setTEnd(moment(new Date()).format("YYYY-MM-DD"));
        setTDesc("");
        setTFile("");
        setErrMsg("");

    }


    useEffect(() => {
        setTStart(moment(new Date()).format("YYYY-MM-DD"));
        setTEnd(moment(new Date()).format("YYYY-MM-DD"));
        setCurdate(moment(new Date()).format("YYYY-MM-DD"));

        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setACList(arr);
                }
            }
        });
        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
              if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                  for (let i = 0; i < res.data.details.length; i++) {
                    if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                      arr.push({
                        value: res.data.details[i].id,
                        label:
                          res.data.details[i].name + " - " + res.data.details[i].code,
                      });
                    }
                    if (arr.length > 0) {
                      setAcID(arr[0]);
                      setAcaID(arr[0]);
                      listall(arr[0]);
                    }
                  }
                 
                }
              }
            });
          }else{
            listall("");
          }
    }, []);

    const [cirerror, setCirError] = useState("");
    function circfile(event) {
        setCirError("");
        setTFile("");
        if (event.target.files.length !== 0) {
            if (event.target.files[0].name.match(/\.(pdf|jpg|jpeg|png)$/i)) {
                setTUrl(URL.createObjectURL(event.target.files[0]));
                setTFile(event.target.files[0]);
            } else {
                setCirError("Circular File should be pdf or jpg or jpeg or png format");
            }
            var size = event.target.files[0].size / 1024 / 1024;
            if (size > 5) {
                setCirError("Circular File size should be less than 5MB");
            }
        }
    }


    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 100,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a onClick={() => viewdet(params.value)}
                            className="btn-sm btn-info me-2"
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                        <a onClick={() => deleteevt(params.value)}
                            className="btn-sm btn-danger me-2"
                        >
                            <i className="fa fa-trash"></i>
                        </a>
                    </div>
                );
            },
        },
        {
            headerName: "Event",
            field: "event_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Start Date",
            field: "event_start",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
           
        },
        {
            headerName: "End Date",
            field: "event_end",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
          
        },
        {
            headerName: "Location",
            field: "location",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Certificate",
            field: "issue_certificate",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Academy",
            field: "academy_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ];
    function viewdet(vid) {
        detailevent(vid).then((res) => {
            if (res.status === true && res.data.details) {
                setEventID(res.data.details.id);
                setTitle(res.data.details.event_name);
                setTLoc(res.data.details.location);
                setEIssue(res.data.details.issue_certificate);

                setTStart(moment(res.data.details.event_start).format("YYYY-MM-DD"));
                setTEnd(moment(res.data.details.event_end).format("YYYY-MM-DD"));
                setTDesc(res.data.details.description);
                if (res.data.details.event_file !== null) {
                    setTUrl(res.data.path + res.data.details.circular);
                }
                academylist().then((res1) => {
                    if (res1.status === true) {
                        let arr = [];
                        if (res1.data.details.length > 0) {
                            for (let i = 0; i < res1.data.details.length; i++) {
                                if (res1.data.details[i].id === res.data.details.academy_id) {
                                    arr.push({
                                        value: res1.data.details[i].id,
                                        label:
                                            res1.data.details[i].name + " - " + res1.data.details[i].code,
                                    });
                                }
                            }
                            setAcaID(arr[0]);
                        }
                    }
                });
                setShow(true);
            }
        })
    }

    function deleteevt(did) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteevent(did).then((response) => {
                    if (response.status === true) {
                        toast.success(response.message);
                        listall(acid)
                    }
                })
            }
        });
    }
    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);

        } else {
            setAcaID("");
        }
    }

    function handleAcad(e) {
        if (e !== null) {
            setAcID(e);
            listall(e);

        } else {
            setAcID("");
            listall("");
        }
    }
    const [errmsg, setErrMsg] = useState("");
    function submitevent(e) {
        e.preventDefault();
        setErrMsg("");
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                setErrMsg("Please Select Academy");
                valid = "Please Select Academy";
            }
        } else {
            valid = "";
        }
        if (valid === "") {
            if (title !== "") {
                if (tloc !== "") {
                    if (tstart !== "") {
                        if (tend !== "") {
                            if (tdesc !== "") {
                                const temp = new FormData();
                                temp.append("event_name", title);
                                temp.append("location", tloc);
                                temp.append("event_start", tstart);
                                temp.append("event_end", tend);
                                temp.append("issue_certificate", eissue);

                                temp.append("description", tdesc);
                                temp.append("circular", tfile);
                                if (localStorage.getItem("Role") === "1" && acaid !== "") {
                                    temp.append("academy_id", acaid.value);
                                }
                                if (eventid !== "") {
                                    temp.append("id", eventid);
                                }
                                createevent(temp).then((res) => {
                                    if (res.status === true) {
                                        handleclose();
                                        toast.success(res.message);
                                        listall(acid)
                                    }
                                })
                            } else {
                                setErrMsg("Please Enter Event Description");
                            }
                        } else {
                            setErrMsg("Please Enter Event End Date");
                        }
                    } else {
                        setErrMsg("Please Enter Event Start Date");
                    }
                } else {
                    setErrMsg("Please Enter Event Location");
                }

            } else {
                setErrMsg("Please Enter Event Name");
            }
        }

    }

    function listall(lid) {
        setEvents([]);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && lid !== "") {
            temp.append("academy_id", lid.value);
        }
       listevent(temp).then((res) => {
                   if (res.status === true) {
                       if(res.data.details.length > 0){
                           const ddata = res.data.details
                           .map((item) => {
                               return {
                                   ...item,
                                   event_start: moment(item.event_start).format("DD-MM-YYYY"),
                                   event_end: moment(item.event_end).format("DD-MM-YYYY"),
                               };
                           })
                           setEvents(ddata);
                       }
                   }
               })
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Events List</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Calendar</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Events List
                    </li>
                </ol>
            </div>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">

                            {localStorage.getItem("Role") === "1" && (
                                <div className="row">
                                    <div className="col-xl-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Select Academy{" "}
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Academy"
                                                value={acid}
                                                options={aclist}
                                                onChange={handleAcad}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div className="res-right">
                                            <a
                                                onClick={handleshow}
                                                variant="success"
                                                type="button"
                                                className="btn my-5 btn-success tx-teko"
                                            >
                                                {" "}
                                                Add Events
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {localStorage.getItem("Role") !== "1" && (
                                <div className="responsive">
                                    <div className="res-right">
                                        <a
                                            onClick={handleshow}
                                            variant="success"
                                            type="button"
                                            className="btn my-1 me-2 btn-success tx-teko"
                                        >
                                            {" "}
                                            Add Events
                                        </a>
                                    </div>
                                </div>
                            )}

                            <div className="ag-theme-alpine ag-style">
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={events}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={["asc", "desc"]}
                                    suppressDragLeaveHidesColumns={true}
                                />
                            </div>

                            <Modal show={show} size="lg">
                                <Modal.Header>
                                    <Modal.Title>Add Event</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="row">
                                        {localStorage.getItem("Role") === "1" && (
                                            <div className="col-xl-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Select Academy{" "}
                                                        <span className="text-danger"> *</span>
                                                    </label>
                                                    <Select
                                                        className="default-select"
                                                        placeholder="Select Academy"
                                                        value={acaid}
                                                        options={aclist}
                                                        onChange={handleAcademy}
                                                        isSearchable={true}
                                                        isClearable
                                                        hidden
                                                    />

                                                </div>
                                            </div>
                                        )}
                                        <div className="col-xl-6">
                                            <label className="form-label">
                                                Event Name<span className="text-danger"> *</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Event Name"
                                                onChange={(e) => setTitle(e.target.value)}
                                                value={title}
                                            />
                                        </div>
                                        <div className="col-xl-6">
                                            <label className="form-label">
                                                Location<span className="text-danger"> *</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Location"
                                                onChange={(e) => setTLoc(e.target.value)}
                                                value={tloc}
                                            />
                                        </div>
                                        <div className="col-xl-6">
                                            <label className="form-label">
                                                Event Start on
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={tstart}
                                                min={curdate}
                                                onChange={(e) => setTStart(e.target.value)}
                                                onKeyPress={(event) => {
                                                    event.preventDefault();
                                                }}
                                                onKeyDown={(event) => {
                                                    event.preventDefault();
                                                }}
                                            />
                                        </div>
                                        <div className="col-xl-6">
                                            <label className="form-label">
                                                Event Ends at
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={tend}
                                                min={tstart}
                                                onChange={(e) => setTEnd(e.target.value)}
                                                onKeyPress={(event) => {
                                                    event.preventDefault();
                                                }}
                                                onKeyDown={(event) => {
                                                    event.preventDefault();
                                                }}
                                            />
                                        </div>
                                        <div className="col-xl-6">
                        <label className="form-label">
                          Issue Certificate<span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) => setEIssue(e.target.value)}
                          value={eissue}
                        >
                          <option value="" disabled>
                            Select Issue Certificate
                          </option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>
                                        <div className="col-xl-6">
                                            <label className="form-label">
                                                Description<span className="text-danger"> *</span>
                                            </label>
                                            <textarea
                                                rows="3"
                                                className="form-control"
                                                placeholder="Enter Description"
                                                onChange={(e) => setTDesc(e.target.value)}
                                                value={tdesc}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">
                                                    Upload Circular{" "}
                                                </label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept=".pdf,.png,.jpg,.jpeg"
                                                    onChange={circfile}
                                                />

                                                {cirerror !== "" && (
                                                    <span className="text-danger">{cirerror}</span>
                                                )}
                                            </div>
                                        </div>
                                        {turl !== "" && eventid !== "" && (
                                            <div className="col-md-6 mt-10">
                                                <a href={turl} target="_blank">
                                                    {turl.slice(-4).toLowerCase() === '.pdf' ? (
                                                        <img src={require("../../../assets/images/pdf.png")} width="100px" height="100px" />
                                                    ) : (
                                                        <img src={turl} width="100px" height="100px" />
                                                    )}
                                                </a>


                                            </div>
                                        )
                                        }

                                    </div>
                                    {errmsg !== "" && <span className="text-danger">{errmsg}</span>}
                                </Modal.Body>
                                <Modal.Footer>
                                    <a className="btn btn-success me-2" onClick={submitevent}>
                                        Submit
                                    </a>
                                    <a className="btn btn-info" onClick={handleclose}>
                                        Close
                                    </a>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
